import React from 'react';
import './ImprintPolicyComponent.css';

const ImprintPolicyComponent: React.FunctionComponent = () => {
    return (
        <div className='w-imprint-policy mt-auto d-flex flex-row justify-content-center align-items-center'>
            <a href="/imprint" className='p-1'>Imprint</a>
            <a href="/policy" className='p-1'>Policy</a>
        </div>
    );
};

export default ImprintPolicyComponent;



// WEBPACK FOOTER //
// ./src/components/ImprintPolicyComponent/ImprintPolicyComponent.tsx